import {saveAs} from 'file-saver';
import moment from 'moment';
import {Card} from 'primereact/card';
import {Column} from 'primereact/column';
import {DataTable} from 'primereact/datatable';
import {Password} from 'primereact/password';
import {TabPanel, TabView} from 'primereact/tabview';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseContainer from '../baseContainers/BaseContainer';
import ActionButton from '../components/ActionButton';
import {CustomDialog} from '../components/CustomDialog';
import {CustomMessages} from '../components/CustomMessages';
import SimpleReactValidator from '../components/validator';
import BlockUi from '../components/waitPanel/BlockUi';
import AuthService from '../services/AuthService';
import InvoiceService from '../services/InvoiceService';
import InvoiceFlsActionDialog from './InvoiceFlsActionDialog';
import publicIp from 'react-public-ip';

class InvoiceDownloadContainer extends BaseContainer {
    constructor(props) {
        super(props);
        this.authService = new AuthService();
        this.invoiceService = new InvoiceService();
        this.state = {
            password: '',
            showDialog: false,
            showFlsDialog: false,
            showRejectionDialog: false,
            rejectionCodeOptions: [],
            fleetStatement: undefined,
            userIp: '',
        };
        this.rejectionValidator = new SimpleReactValidator({}, this.translate);
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    getContainerListName() {
        return 'invoice-download-container';
    }

    componentDidMount() {
        super.componentDidMount();
        const {t} = this.props;
        this.enumService
            .getEnumList('EcFleetStatementRejecetionCode', t)
            .then((rejectionCodeOptions) => {
                this.setState(
                    {
                        rejectionCodeOptions,
                    },
                    () => {
                        this.unblockUi();
                    }
                );
            })
            .catch(() => {
                this.showErrorMessage(t('fleetStatement.rejectionCodeListError'));
                this.unblockUi();
            });
        publicIp.v4().then((response) => {
            this.setState({
                userIp: response,
            });
        });
    }

    handleFormSubmit(e) {
        const {t, invoiceNumber} = this.props;
        const {password} = this.state;
        if (e !== undefined) {
            e.preventDefault();
        }
        if (this.validator.allValid()) {
            this.blockUi();
            if (invoiceNumber.includes('PPS')) {
                this.invoiceService
                    .getFleetStatementPublic(invoiceNumber, password)
                    .then((fleetStatement) => {
                        this.setState({fleetStatement, showFlsDialog: true}, () => this.unblockUi());
                    })
                    .catch((err) => {
                        this.showErrorMessage(t('fleetStatement.getFleetStatementError'));
                        this.unblockUi();
                    });
            } else {
                this.invoiceService
                    .acceptOngPublic(invoiceNumber, password, false)
                    .then((res) => {
                        if (!res.correctPassword) {
                            this.showErrorMessage(t('invoice.downloadPdfError'));
                            this.unblockUi();
                        } else if (res.ongToAccept) {
                            // this.setState({showDialog: true, invoiceToDownload: res});
                            this.setState({
                                showDialog: true,
                                invoiceToDownload: res,
                            });
                            this.unblockUi();
                        } else {
                            this.invoiceService
                                .downloadInvoicePdfPublic(res.petraFileId, invoiceNumber, password)
                                .then((response) => {
                                    saveAs(response, `${invoiceNumber}.pdf`);
                                    this.unblockUi();
                                })
                                .catch((err) => {
                                    this.showErrorMessage(t('invoice.downloadPdfError'));
                                    this.unblockUi();
                                });
                        }
                    })
                    .catch((err) => {
                        if (err?.errorCode === 'EC_DOWNLOAD_INVOICE_BAD_CREDENTIALS') {
                            this.showErrorMessage(t('error.invoiceDownloadBadCredentialsError'));
                        } else {
                            this.showErrorMessage(t('error.invoiceDownloadError'));
                        }
                        this.unblockUi();
                    });
            }
        } else {
            this.validator.showMessages();
            // rerender to show messages for the first time
            this.scrollToError = true;
            this.forceUpdate();
        }
    }

    renderFlsDialog() {
        const {t} = this.props;
        const {activeIndex} = this.state;
        return (
            <TabView activeIndex={activeIndex} onTabChange={(e) => this.setState({activeIndex: e.index})}>
                <TabPanel header={t('fleetStatement.fuelList')}>{this.renderFleetStatement('fuelList')}</TabPanel>
                <TabPanel header={t('fleetStatement.adBlueList')}>{this.renderFleetStatement('adBlueList')}</TabPanel>
                <TabPanel header={t('fleetStatement.lpgList')}>{this.renderFleetStatement('lpgList')}</TabPanel>
                <TabPanel header={t('fleetStatement.goodsList')}>{this.renderFleetStatement('goodsList')}</TabPanel>
            </TabView>
        );
    }

    renderFleetStatement(type) {
        const {t} = this.props;
        let list;
        if (this.state.fleetStatement[type] !== undefined && this.state.fleetStatement[type] instanceof Array) {
            list = this.state.fleetStatement[type];
        } else {
            list = [];
        }
        let columns = [
            {
                field: 'lp',
                header: t('fleetStatement.column.lp'),
                sortable: true,
            },
            {
                field: 'uuid',
                header: t('fleetStatement.column.uuid'),
                sortable: true,
            },
            {
                field: 'dateTime',
                header: t('fleetStatement.column.date'),
                sortable: true,
                body: this.dateTemplate.bind(this, 'dateTime', 'YYYY-MM-DD HH:mm:ss'),
            },
            {
                field: 'fleetType',
                header: t('fleetStatement.column.fleetType'),
                sortable: true,
            },
            {
                field: 'cbkMaterialId',
                header: t('fleetStatement.column.cbkMaterialId'),
                sortable: true,
            },
            {
                field: 'quantity',
                header: t('fleetStatement.column.quantity'),
                sortable: true,
            },
            {
                field: 'buyBackPrice',
                header: t('fleetStatement.column.buyBackPrice'),
                sortable: true,
            },
            {
                field: 'singleTrxNettoAmount',
                header: t('fleetStatement.column.singleTrxNettoAmount'),
                sortable: true,
            },
        ];
        switch (type) {
            case 'fuelList':
                columns.push(
                    {
                        field: 'coPpMaxCns',
                        header: t('fleetStatement.column.coPpMaxCns'),
                        sortable: true,
                    },
                    {
                        field: 'chInvoiceNumber',
                        header: t('fleetStatement.column.chInvoiceNumber'),
                        sortable: true,
                    },
                    {
                        field: 'wholesalePrice',
                        header: t('fleetStatement.column.wholesalePrice'),
                        sortable: true,
                    },
                    {
                        field: 'partnerMargin',
                        header: t('fleetStatement.column.partnerMargin'),
                        sortable: true,
                    },
                    {
                        field: 'maxBuyBackPrice',
                        header: t('fleetStatement.column.maxBuyBackPrice'),
                        sortable: true,
                    },
                    {
                        field: 'pylonPrice',
                        header: t('fleetStatement.column.pylonPrice'),
                        sortable: true,
                    },
                    {
                        field: 'pylonNettoPrice',
                        header: t('fleetStatement.column.pylonNettoPrice'),
                        sortable: true,
                    },
                    {
                        field: 'pylonNettoMinusMaxBuyBackPrice',
                        header: t('fleetStatement.column.pylonNettoMinusMaxBuyBackPrice'),
                        sortable: true,
                    }
                );
                break;
            case 'adBlueList':
                columns.push(
                    {
                        field: 'pylonPrice',
                        header: t('fleetStatement.column.pylonPrice'),
                        sortable: true,
                    },
                    {
                        field: 'grossAmount',
                        header: t('fleetStatement.column.grossAmount'),
                        sortable: true,
                    },
                    {
                        field: 'grossPrice',
                        header: t('fleetStatement.column.grossPrice'),
                        sortable: true,
                    }
                );
                break;
            case 'lpgList':
                columns.push(
                    {
                        field: 'pylonPrice',
                        header: t('fleetStatement.column.pylonPrice'),
                        sortable: true,
                    },
                    {
                        field: 'grossPrice',
                        header: t('fleetStatement.column.grossPrice'),
                        sortable: true,
                    }
                );
                break;
            case 'goodsList':
                columns.push({
                    field: 'grossPrice',
                    header: t('fleetStatement.column.grossPrice'),
                    sortable: true,
                });
                break;
            default:
                break;
        }
        columns.push(
            {
                field: 'vatType',
                header: t('fleetStatement.column.vatType'),
                sortable: true,
            },
            {
                field: 'trxGrossAmount',
                header: t('fleetStatement.column.trxGrossAmount'),
                sortable: true,
            }
        );
        switch (type) {
            case 'adBlueList':
            case 'lpgList':
            case 'goodsList':
                columns.push(
                    {
                        field: 'discountPercent',
                        header: t('fleetStatement.column.discountPercent'),
                        sortable: true,
                    },
                    {
                        field: 'discountAmount',
                        header: t('fleetStatement.column.discountAmount'),
                        sortable: true,
                    }
                );
                break;
            default:
                break;
        }
        const dynamicColumns = columns.map((col) => {
            return (
                <Column
                    selectionMode={col.selectionMode}
                    key={col.key ? col.key : col.field}
                    field={col.field}
                    filter
                    filterField={col.field}
                    showFilterMenu={false}
                    header={col.header}
                    body={col.body}
                    bodyClassName={col.bodyClassName}
                    headerClassName={col.headerClassName}
                    className={col.className}
                    sortable={col.sortable}
                    sortField={col.sortField !== undefined ? col.sortField : col.field}
                    style={col.width !== undefined ? {width: col.width} : null}
                />
            );
        });
        return (
            <DataTable
                id='dataTable'
                key='data-table'
                emptyMessage={this.translate('list.empty')}
                className='p-datatable-responsive'
                autoLayout={true}
                value={list}
                sortField='lp'
                sortOrder={1}
                rows={list.length}
                lazy={false}
            >
                {dynamicColumns}
            </DataTable>
        );
    }

    renderDialog() {
        const {t, invoiceNumber} = this.props;
        const {password, invoiceToDownload} = this.state;
        return (
            <div>
                <div className='invoice-property'>
                    {`${t('invoice.invoiceNumberFilter')}: `}
                    <div className='invoice-property-value'>{invoiceToDownload?.positions[0]?.docNumber}</div>
                </div>
                <div className='invoice-property'>
                    {`${t('invoice.documentDate')}: `}
                    <div className='invoice-property-value'>
                        {moment(invoiceToDownload?.positions[0].docDate).format('DD-MM-YYYY')}
                    </div>{' '}
                </div>
                <div className='product-list'>
                    <div className='product-list-header'>
                        <div className='name'>{t('invoice.productName')}</div>
                        <div className='quantity'>{t('invoice.productAmount')}</div>
                    </div>
                    {invoiceToDownload?.positions !== null && invoiceToDownload?.positions.length > 0
                        ? invoiceToDownload?.positions?.map((el) => {
                              return (
                                  <div key={el.goodsName} className='product-list-row'>
                                      <div className='name'>{el.goodsName}</div>
                                      <div className='quantity'>{el.quantity}</div>
                                  </div>
                              );
                          })
                        : null}
                </div>
                <div className='button-row'>
                    <ActionButton
                        label={t('invoice.invoiceDownloadConfirm')}
                        variant='next-button pay24-button'
                        handleClick={(e) => {
                            e.preventDefault();
                            this.invoiceService
                                .acceptOngPublic(invoiceNumber, password, true)
                                .then((res) => {
                                    if (!res.correctPassword && !res.acceptanceSaved) {
                                        this.showErrorMessage(t('invoice.downloadPdfError'));
                                        this.unblockUi();
                                    } else if (res.ongToAccept) {
                                        this.setState({
                                            showDialog: true,
                                            invoiceToDownload: res,
                                        });
                                        this.unblockUi();
                                    } else {
                                        this.invoiceService
                                            .downloadInvoicePdfPublic(res.petraFileId, invoiceNumber, password)
                                            .then((response) => {
                                                saveAs(response, `${invoiceNumber}.pdf`);
                                                this.unblockUi();
                                            })
                                            .catch((err) => {
                                                this.showErrorMessage(t('invoice.downloadPdfError'));
                                                this.unblockUi();
                                            });
                                    }
                                })
                                .catch((err) => {
                                    if (err?.errorCode === 'EC_DOWNLOAD_INVOICE_BAD_CREDENTIALS') {
                                        this.showErrorMessage(t('error.invoiceDownloadBadCredentialsError'));
                                    } else {
                                        this.showErrorMessage(t('error.invoiceDownloadError'));
                                    }
                                    this.unblockUi();
                                });
                        }}
                    />
                </div>
            </div>
        );
    }
    fleetStatementAction(actionType) {
        const {t, invoiceNumber} = this.props;
        const {userIp, actionForm} = this.state;
        if (actionType === 'ACCEPT' || (actionType === 'REJECT' && this.rejectionValidator.allValid())) {
            this.blockUi();
            this.invoiceService
                .fleetStatementActionPublic(
                    undefined,
                    invoiceNumber.replace('PPS', ''),
                    userIp,
                    actionType,
                    actionType !== 'ACCEPT' ? actionForm.rejectionCode : undefined,
                    actionType !== 'ACCEPT' ? actionForm.rejectionText : undefined
                )
                .then((res) => {
                    if (actionType === 'ACCEPT') {
                        this.showSuccessMessage(t('fleetStatement.acceptSuccess'));
                    } else if (actionType === 'REJECT') {
                        this.showSuccessMessage(t('fleetStatement.rejectionSuccess'));
                    }
                    this.setState({
                        showFlsDialog: false,
                        showRejectionDialog: false,
                        password: '',
                        actionForm: {
                            rejectionCode: undefined,
                            rejectionText: '',
                        },
                    });
                    this.unblockUi();
                })
                .catch((err) => {
                    if (actionType === 'ACCEPT') {
                        this.showErrorMessage(err.message);
                    } else if (actionType === 'REJECT') {
                        // this.showErrorMessage(t('fleetStatement.rejectionError'));
                        this.showErrorMessage(err.message);
                    }
                    this.unblockUi();
                });
        } else {
            this.rejectionValidator.showMessages();
            // rerender to show messages for the first time
            this.scrollToError = true;
            this.forceUpdate();
        }
    }

    render() {
        const {t, invoiceNumber} = this.props;
        const {password} = this.state;
        return (
            <React.Fragment>
                <BlockUi tag='div' blocking={this.state.blocking || this.state.loading} loader={this.loader}>
                    <div id='main-invoice-download'>
                        <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)}></CustomMessages>
                        {this.state.fleetStatement !== undefined ? (
                            <CustomDialog
                                name='fleet-statement-dialog'
                                className='fleet-statement-dialog'
                                visible={this.state.showFlsDialog}
                                viewMode={this.props.viewMode}
                                onHide={() => {
                                    this.setState({showFlsDialog: false});
                                }}
                                modal
                                header={t('fleetStatement.dialogHeader')}
                            >
                                <Card
                                    footer={() => (
                                        <div className='footer-dialog-button-container'>
                                            <ActionButton
                                                label={t('fleetStatement.downloadPdf')}
                                                variant='next-button'
                                                handleClick={(e) => {
                                                    e.preventDefault();
                                                    this.invoiceService
                                                        .downloadInvoicePdfPublic(undefined, invoiceNumber, password)
                                                        .then((response) => {
                                                            saveAs(response, `${invoiceNumber}.pdf`);
                                                            this.unblockUi();
                                                        })
                                                        .catch((err) => {
                                                            this.showErrorMessage(t('invoice.downloadPdfError'));
                                                            this.unblockUi();
                                                        });
                                                }}
                                            />
                                            <ActionButton
                                                label={t('fleetStatement.rejectAction')}
                                                variant='next-button fullred'
                                                handleClick={(e) => {
                                                    e.preventDefault();
                                                    this.setState({showRejectionDialog: true});
                                                }}
                                            />
                                            <ActionButton
                                                label={t('fleetStatement.acceptAction')}
                                                variant='next-button'
                                                handleClick={(e) => {
                                                    e.preventDefault();
                                                    this.fleetStatementAction('ACCEPT');
                                                }}
                                            />
                                        </div>
                                    )}
                                >
                                    {this.renderFlsDialog()}
                                </Card>
                            </CustomDialog>
                        ) : null}
                        <InvoiceFlsActionDialog
                            hideDialog={() => {
                                this.setState({showRejectionDialog: false});
                            }}
                            invoiceNumber={this.props.invoiceNumber}
                            showRejectionDialog={this.state.showRejectionDialog}
                            rejectionCodeOptions={this.state.rejectionCodeOptions}
                            blockUi={this.blockUi}
                            unblockUi={this.unblockUi}
                            showMessage={this.showMessage}
                            embedded
                            _isMounted={this._isMounted}
                        />
                        <CustomDialog
                            name='invoice-download-dialog'
                            className='invoice-download-dialog'
                            visible={this.state.showDialog}
                            viewMode={this.props.viewMode}
                            onHide={() => {
                                this.setState({showDialog: false, invoiceToDownload: undefined});
                            }}
                            modal
                            header={t('invoice.downloadInvoiceDialogHeader')}
                        >
                            {this.renderDialog()}
                        </CustomDialog>
                        <div className='invoice-download-background-container'>
                            <img src='/images/login-moya-background.svg' className='login-background-moya' alt='logo moya' />
                            <div className='login-moya-logo-container'>
                                <img src='/images/login-moya-logo.svg' className='login-moya-logo' alt='logo moya' />
                            </div>
                            <div className='invoice-download-text-container'>
                                <span className='invoice-download-welcome-text'>{t('invoiceDownload.welcomeText')}</span>
                            </div>
                            <div className='invoice-download-guide-text-container'>
                                <div className='invoice-download-guide-text'>{t('invoiceDownload.guideText')}</div>
                            </div>
                            <div className='row'>
                                <div className='login-label'>{t('login.form.password')}</div>
                                <Password
                                    inputClassName='login-input'
                                    aria-label={t('login.form.password')}
                                    key={'invoicePassword'}
                                    id={'invoicePassword'}
                                    name={'password'}
                                    placeholder={''}
                                    inputStyle={{width: '100%'}}
                                    style={{width: '100%'}}
                                    value={this.state.password}
                                    onChange={(e) => this.handleChange('TEXT', undefined, e, undefined, '')}
                                    promptLabel={t('login.form.password')}
                                    feedback={false}
                                    required={true}
                                    validator={this.validator}
                                    validators='required'
                                />
                                <div aria-live='assertive' className='login-form-validation'>
                                    {this.validator.message('invoicePassword', t('login.form.password'), this.state.password, 'required')}
                                </div>
                                <div className='col-12'>
                                    <ActionButton
                                        label={t('details.download')}
                                        variant='login-button blue'
                                        handleClick={this.handleFormSubmit}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </BlockUi>
            </React.Fragment>
        );
    }
}

InvoiceDownloadContainer.propTypes = {};

export default withTranslation()(InvoiceDownloadContainer);
